export default __webpack_public_path__ + "static/push-4bbbae9f64efa78690a082916602bb51.png";